/**
 * Job scope change status filter.
 */
export type JobScopeChangeStatusFilterOption =
  (typeof allJobScopeChangeStatusFilterOptions)[number]

/**
 * All job scope change status filter options.
 *
 * Saved list settings refer to options by position, so only ever append.
 */
export const allJobScopeChangeStatusFilterOptions = [
  'PendingReview',
  'Accepted',
  'Rejected',
] as const
